{
  "Accessibility Menu": "Menú d'accessibilitat",
  "Reset settings": "Restablir configuració",
  "Close": "Tancar",
  "Content Adjustments": "Ajustos de contingut",
  "Adjust Font Size": "Ajustar la mida de la font",
  "Highlight Title": "Destacar títol",
  "Highlight Links": "Destacar enllaços",
  "Readable Font": "Font llegible",
  "Color Adjustments": "Ajustos de color",
  "Dark Contrast": "Contrast fosc",
  "Light Contrast": "Contrast clar",
  "High Contrast": "Alt contrast",
  "High Saturation": "Alta saturació",
  "Low Saturation": "Baixa saturació",
  "Monochrome": "Monocrom",
  "Tools": "Eines",
  "Reading Guide": "Guia de lectura",
  "Stop Animations": "Aturar animacions",
  "Big Cursor": "Cursor gran",
  "Increase Font Size": "Augmentar mida de la font",
  "Decrease Font Size": "Reduir mida de la font",
  "Letter Spacing": "Espaiat entre lletres",
  "Line Height": "Alçada de línia",
  "Font Weight": "Gruix de la font",
  "Dyslexia Font": "Font per a dislèxia",
  "Language": "Idioma",
  "Open Accessibility Menu": "Obrir menú d'accessibilitat",
  "Accessibility Profiles": "Perfils d'accessibilitat",
  "Seizure Safe Profile": "Perfil segur per a epilèpsia",
  "Stops animations and reduces color saturation.": "Atura les animacions i redueix la saturació del color.",
  "Blind Profile": "Perfil per a persones cegues",
  "Activates the screen reader for auditory navigation.": "Activa el lector de pantalla per a la navegació auditiva.",
  "Visually Impaired Profile": "Perfil per a persones amb discapacitat visual",
  "Enhances contrast and readability for low vision.": "Millora el contrast i la llegibilitat per a persones amb baixa visió.",
  "ADHD Friendly Profile": "Perfil amigable per a TDAH",
  "Reduces distractions for better focus.": "Redueix les distraccions per millorar la concentració.",
  "Cognitive & Learning Profile": "Perfil cognitiu i d'aprenentatge",
  "Helpful tools for reading and comprehension.": "Eines útils per a la lectura i la comprensió.",
  "Motor Impaired Profile": "Perfil per a discapacitat motriu",
  "Optimizes the site for keyboard-only navigation.": "Optimitza el lloc web per a la navegació només amb teclat.",
  "Headings": "Encapçalaments",
  "Landmarks": "Punts de referència",
  "Links": "Enllaços",
  "Focus element": "Element amb focus",
  "Visit link": "Visitar enllaç"
}